export default (id: string) => {
  return id ? (id?.split('/')[2] as string) : '';
};
